import React from 'react'
import { Form, Row, Col, Button } from 'react-bootstrap'

// definitions
import { AccountXeroOrgWithData } from '../../../../screens/subsync/subsync'
import { StripeTaxRate, XeroAPIContact } from '../../../../../../back-end/utilities/apiDefinitions'
import { TaxAsLineItemSettings } from './TaxAsLineItemSettings'
import { TaxRateMapping } from './TaxRateMapping'
import { DetailedStripeOrgAccountXeroOrg, Error } from '../settings'

interface TaxSettingsProps {
	orgMapping: DetailedStripeOrgAccountXeroOrg | undefined
	mappedXeroOrg: AccountXeroOrgWithData | undefined
	stripeOrgID: string
	stripeTaxRates: StripeTaxRate[]
	handleSettingsUpdate: (stripeOrgID: string, values: { [name: string]: string | boolean | XeroAPIContact | undefined }) => void
	handleTaxRateUpdate: (stripeOrgID: string, stripeTaxRateID: string, name: string, value: string) => void
	handleTaxRateAdd: (stripeOrgID: string, stripeTaxRateID: string, name: string, value: string) => void
	errors: Error[]
}

const TaxSettings = (props: TaxSettingsProps) => {
	const [onlyShowErrors, setOnlyShowErrors] = React.useState(false)

	return (
		<>
			<Form.Group as={Row} style={{ height: '2.5rem' }}>
				<Col sm="2">
					<Form.Label className="mr-3">Map Stripe taxes to</Form.Label>
				</Col>
				<Col className="d-flex justify-content-start">
					<Button
						id={`${props.stripeOrgID}-mapping-type-account`}
						variant="outline-secondary"
						className={'option-button ' + (props.orgMapping?.stripeOrgAccountXeroOrgSettings?.taxAsLineItem === false ? 'active' : '')}
						onClick={() =>
							props.handleSettingsUpdate(props.stripeOrgID, {
								taxAsLineItem: false,
							})
						}
					>
						Xero tax rates
					</Button>
					<Button
						id={`${props.stripeOrgID}-mapping-type-item`}
						variant="outline-secondary"
						className={'option-button ' + (props.orgMapping?.stripeOrgAccountXeroOrgSettings?.taxAsLineItem === true ? 'active' : '')}
						onClick={() =>
							props.handleSettingsUpdate(props.stripeOrgID, {
								taxAsLineItem: true,
							})
						}
						disabled={props.orgMapping?.stripeOrgAccountXeroOrgProcessingType === 'Rollup'}
					>
						Xero line item
					</Button>
				</Col>
			</Form.Group>
			{props.errors.length > 0 && (
				<Row>
					<Col sm={2}>
						<Form.Label style={LabelStyle}>Only show rows with warnings</Form.Label>
					</Col>
					<Form.Check
						type={'switch'}
						id={`onlyShowErrors`}
						name={'onlyShowErrors'}
						checked={onlyShowErrors}
						onChange={(e) => setOnlyShowErrors(e.target.checked)}
					/>
				</Row>
			)}
			{props.orgMapping?.stripeOrgAccountXeroOrgSettings?.taxAsLineItem ? (
				<TaxAsLineItemSettings {...props} />
			) : (
				<>
					{props.stripeTaxRates.filter((tr) => tr.isStripeGenerated).length > 0 && <p className="font-weight-semi-bold ml-2 mt-3">Tax Mapping</p>}
					{props.stripeTaxRates
						.filter((tr) => !tr.isStripeGenerated)
						.map((taxRate) => {
							return (
								<TaxRateMapping
									key={taxRate.stripeTaxRateID}
									stripeTaxRate={taxRate}
									orgMapping={props.orgMapping!}
									xeroTaxRates={props.mappedXeroOrg!.taxRates}
									stripeOrgId={props.stripeOrgID!}
									handleTaxRateUpdate={props.handleTaxRateUpdate}
									handleTaxRateAdd={props.handleTaxRateAdd}
									onlyShowErrors={onlyShowErrors}
									error={props.errors.find((error) => error.id === taxRate.stripeTaxRateID)}
								/>
							)
						})}

					{props.stripeTaxRates.filter((tr) => tr.isStripeGenerated).length > 0 && (
						<>
							<p className="font-weight-semi-bold ml-2 mt-3">Stripe Generated Tax Mapping</p>
							{props.stripeTaxRates
								.filter((tr) => tr.isStripeGenerated)
								.map((taxRate) => {
									return (
										<TaxRateMapping
											key={taxRate.stripeTaxRateID}
											stripeTaxRate={taxRate}
											orgMapping={props.orgMapping!}
											xeroTaxRates={props.mappedXeroOrg!.taxRates}
											stripeOrgId={props.stripeOrgID!}
											handleTaxRateUpdate={props.handleTaxRateUpdate}
											handleTaxRateAdd={props.handleTaxRateAdd}
											onlyShowErrors={onlyShowErrors}
											error={props.errors.find((error) => error.id === taxRate.stripeTaxRateID)}
										/>
									)
								})}
						</>
					)}
				</>
			)}
		</>
	)
}

const LabelStyle = {
	lineHeight: '2.5rem',
}

export { TaxSettings }
export type { TaxSettingsProps }
